import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import {
  FaList,
  FaChartBar,
  FaPhone,
  FaClock,
  FaBan,
  FaCheckCircle,
  FaRedo,
} from "react-icons/fa";
import { getApiCall } from "../../service/httpCall";
import { API_DASHBOARD_OUTBOUND_CAMPAIGNS_STATS } from "../../service/url";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { USER_ROLES } from "../../utilities/constant";

const StatCard = ({ icon, label, value, borderColor, textColor }) => {
  return (
    <Card
      className="shadow-sm"
      style={{
        borderRadius: "40px",
        border: `2px solid ${borderColor}`,
        padding: "10px 20px",
        marginBottom: "-2px",
      }}
    >
      <Card.Body className="d-flex align-items-center justify-content-center gap-1 p-0">
        <span style={{ color: textColor, fontSize: "15px" }}>{icon}</span>
        <span style={{ color: textColor, fontWeight: 600 }}>
          {label}: {value ?? "-"}
        </span>
      </Card.Body>
    </Card>
  );
};

const DashboardCampaignDetails = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loggedInUserRole, setLoggedInUserRole] = useState(null);

  useEffect(() => {
    async function checkUserRole() {
      const rawUser = await AsyncStorage.getItem("user");
      if (!rawUser) {
        console.error("User not found in AsyncStorage");
        return null; // or handle as needed
      }
  
      let user;
      try {
        user = JSON.parse(rawUser);
      } catch (e) {
        console.error("Invalid JSON in user from AsyncStorage", e);
        return null;
      }
      if (user.role) {
        setLoggedInUserRole(user.role);
      }
    }
    checkUserRole();
  }, []);

  useEffect(() => {
    if (!loggedInUserRole) return;
    if (loggedInUserRole == USER_ROLES.CALL_CENTRE_AGENT) {
      return;
    }
    fetchDashboardStats();
  }, [loggedInUserRole]);

  const fetchDashboardStats = async () => {
    try {
      const response = await getApiCall(
        API_DASHBOARD_OUTBOUND_CAMPAIGNS_STATS
      );

      setDashboardData(response?.campaigns || {});
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
    }
  };

  const stats = [
    {
      label: "Total",
      value: dashboardData?.totalCampaigns,
      icon: <FaList />,
      color: "#0d6efd",
    },
    {
      label: "Camp This Month",
      value: dashboardData?.totalCampaignsThisMonth,
      icon: <FaChartBar />,
      color: "#000000",
    },
    {
      label: "Dialed",
      value: dashboardData?.totalProcessed,
      icon: <FaPhone style={{ transform: "rotate(100deg)" }} />,
      color: "#00d118",
    },
    {
      label: "Running",
      value: dashboardData?.runningCampaigns,
      icon: <FaClock />,
      color: "#6f42c1",
    },
    {
      label: "Errored",
      value: dashboardData?.erroredCampaigns,
      icon: <FaBan />,
      color: "#dc3545",
    },
    {
      label: "Connected",
      value: dashboardData?.totalConnected,
      icon: <FaCheckCircle />,
      color: "#198754",
    },
    {
      label: "Total Numbers",
      value: dashboardData?.totalNos,
      icon: <FaChartBar />,
      color: "#fd7e14",
    },
    // {
    //   label: "Retry Count",
    //   value: dashboardData?.retryCount,
    //   icon: <FaRedo />,
    //   color: "#c49300",
    // },
    {
      label: "Completed",
      value: dashboardData?.completedCampaigns,
      icon: <FaChartBar />,
      color: "#0dcaf0",
    },
  ];

  return (
    <Container fluid className="py-4">
      <h5 className="mb-1">Campaign Details</h5>

      <Row className="gx-2 gy-1">
        {stats.map((item, index) => (
          <Col key={index} md={4} lg={3}>
            <StatCard
              icon={item.icon}
              label={item.label}
              value={item.value}
              borderColor={item.color}
              textColor={item.color}
            />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default DashboardCampaignDetails;